(() => {
  function init(section) {
    const pile = section.querySelector('[data-memory-pile]');
    if (!pile || pile.dataset.initialized) return;
    pile.dataset.initialized = 'true';
    const photos = [...pile.querySelectorAll('.nm-polaroid')];
    const controls = section.querySelector('[data-memory-controls]');
    const position = section.querySelector('[data-memory-position]');
    const directions = [...section.querySelectorAll('[data-memory-direction]')];
    const replay = section.querySelector('[data-memory-replay]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    let index = 0, observer, timer, scrollFrame;
    function sync() {
      const centre = pile.getBoundingClientRect().left + pile.clientWidth / 2;
      if (pile.scrollWidth > pile.clientWidth + 10) index = photos.reduce((best, photo, i) => {
        const rect = photo.getBoundingClientRect(), previous = photos[best].getBoundingClientRect();
        return Math.abs(rect.left + rect.width / 2 - centre) < Math.abs(previous.left + previous.width / 2 - centre) ? i : best;
      }, 0);
      if (position) position.textContent = position.dataset.label.replace('[current]', String(index + 1)).replace('[total]', String(photos.length));
      directions.forEach(button => button.disabled = Number(button.dataset.memoryDirection) < 0 ? index === 0 : index === photos.length - 1);
    }
    function move(direction) {
      const target = photos[Math.max(0, Math.min(photos.length - 1, index + direction))];
      if (!target) return;
      pile.scrollTo({left: target.offsetLeft - (pile.clientWidth - target.offsetWidth) / 2, behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    directions.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.memoryDirection)), {signal: events.signal}));
    pile.addEventListener('scroll', () => { cancelAnimationFrame(scrollFrame); scrollFrame = requestAnimationFrame(sync); }, {passive:true, signal:events.signal});
    pile.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } }, {signal:events.signal});
    function settle() { pile.classList.remove('is-waiting','is-playing'); clearTimeout(timer); replay.hidden = true; }
    function play() {
      if (reduced.matches) return settle();
      pile.classList.remove('is-playing'); pile.classList.add('is-waiting');
      requestAnimationFrame(() => requestAnimationFrame(() => { pile.classList.remove('is-waiting'); pile.classList.add('is-playing'); timer = setTimeout(() => { pile.classList.remove('is-playing'); replay.hidden=false; }, 1450); }));
    }
    if (controls) controls.hidden=false;
    sync();
    replay.addEventListener('click', play, {signal:events.signal});
    if (!reduced.matches && 'IntersectionObserver' in window) {
      pile.classList.add('is-waiting'); observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) {play();observer.disconnect();} }, {threshold:.12});observer.observe(pile);
    }
    reduced.addEventListener('change', () => { if(reduced.matches) settle(); }, {signal:events.signal});
    window.addEventListener('resize', sync, {signal:events.signal});
    document.addEventListener('shopify:section:unload', event => {if(event.target.contains(section)){events.abort();observer?.disconnect();clearTimeout(timer);cancelAnimationFrame(scrollFrame);}}, {signal:events.signal});
  }
  document.querySelectorAll('.nm-memories').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.nm-memories').forEach(init));
})();
